import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExportCsvImeiService {
    private readonly baseUrl = environment.baseUrl;

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get
     */
    exportCSV(imeis: string[]): Observable<any> {
        return this._httpClient.get(`${this.baseUrl}/api/user/devices/export`, {
            params: { imeis },
            responseType: 'blob',
        });
    }
}
